import React from 'react';
import { PricingFAQ } from './components/PricingFAQ';

const PricingFAQApp = props => <PricingFAQ {...props} />;

export default PricingFAQApp;
